import DSponsorsPage from './DSponsorsPage'

export default DSponsorsPage
